import bootstrappedData from 'base/lib/singletons/bootstrapped_data'
import Chaplin from 'everlane-chaplin'
import history from 'base/lib/browser_history'

export function wantsWeb(href) {
  const WEB_PATHS = [
    /^$/,
    /^.*\/$/,
    /^\/ab_tests/,
    /^\/account$/,
    /^\/account\/address/,
    /^\/account\/billing/,
    /^\/account\/info/,
    /^\/account\/invite/,
    /^\/account\/orders$/,
    /^\/account\/orders\/\D[0-9]{9}$/,
    /^\/account\/redeem/,
    /^.*\/back-to-work-outfits/,
    /^.*\/checkout/,
    /^.*\/collections\//,
    /^\/gift-returns\/new/,
    /^\/invite/,
    /^.*\/mens/,
    /^.*\/mix-and-match\//,
    /^.*\/products\//,
    /^\/redeem$/,
    /^\/search$/,
    /^.*\/swim-sets/,
    /^.*\/womens/,
  ]

  return WEB_PATHS.some(re => re.test(href))
}

// Currently only Afterpay checkout, which redirects the user to a url like
// https://portal.sandbox.afterpay.com/us/checkout/?token=foo
// I would prefer checking the hostname or query but that would require
// refactoring from using href only
function isThirdParty(href) {
  return /^\/us\/checkout/.test(href)
}

// Returning false will cause links wrapped by ManualLinkRouter to hard land.
// Params: href - String, eg '/checkout', '/products/foo', '/'
export function isInternal(href) {
  const { protocol, hostname } = document.location
  const url = new URL(href, document.location)
  return (
    url.protocol === protocol && url.hostname === hostname && !wantsWeb(href) && !isThirdParty(href)
  )
}

export function rewriteRouteIfNeeded(href) {
  if (href.includes('/checkout/preview')) {
    return '/checkout'
  }
  return href
}

function isAnotherHost(href) {
  const url = new URL(href, window.location)
  return url.host != window.location.host
}

const routeTo = (route, { hard = false, newTab = false } = {}) => {
  const newRoute = rewriteRouteIfNeeded(route)

  if (hard) {
    if (newTab) {
      window.open(newRoute, '_blank')
    } else {
      window.location = newRoute
    }
  } else if (!wantsWeb(newRoute)) {
    history.push(newRoute)
  } else {
    window.location = newRoute
  }
}

const chaplinRouteTo = (route, { hard = false, newTab = false } = {}) => {
  const newRoute = rewriteRouteIfNeeded(route)

  if ((hard && !newTab) || isAnotherHost(newRoute)) {
    window.location = newRoute
    return
  }

  if (hard && newTab) {
    window.open(newRoute, '_blank')
    return
  }

  Chaplin.utils.redirectTo({
    url: newRoute,
    replace: true,
  })
}

const stubbable = (...args) => {
  stubbable.implementation(...args)
}

stubbable.implementation = bootstrappedData.isOnReactRouter ? routeTo : chaplinRouteTo

export default stubbable
